<template>
  <div class="header_wrapper">
    <div class="header">
      <el-row :gutter="20">
        <el-col :span="7">
          <div class="logo">
            <img src="@/assets/images/logo.png" alt="">
          </div>
        </el-col>
        <el-col :span="12">
          <ul class="top_nav">
            <li><a href="http://ncfiva.com/" target="_blank">学校官网</a></li>
            <li><a href="http://www.ncfiva.com/" target="_blank">招生就业</a></li>
          </ul>
        </el-col>
        <el-col :span="5">
          <div class="top_other">
            <ul>
              <li>
                <el-avatar shape="square" size="medium" fit="cover"
                  :src="userInfo.Icon? baseUrl+userInfo.Icon:avatar">
                </el-avatar>
              </li>
              <li>{{store.state.userInfo.Name}}</li>
              <li @click="logout">安全退出</li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script lang="ts">
// import { } from "@ant-design/icons-vue";

import { defineComponent} from "vue"

import { useRouter } from "vue-router";
import {useStore} from "vuex"
import {userDetailApi} from "@/api/common"
export default defineComponent({
  name: "",
  components: {},
  setup() {
    //*********** definning variables start **********//
    const router = useRouter()
    const store = useStore()
    const baseUrl = process.env.VUE_APP_BASE_URL
    const avatar = require("@/assets/images/avatar.svg")
    // let name = ref(null)
    //*********** definning variables end **********//
    //*********** initData start **********//
    let userInfoStr = localStorage.getItem('userInfo')
    let userInfo = null
    if(userInfoStr){
      userInfo = JSON.parse(userInfoStr)
      getUserDetail(userInfo.Id)
    }
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    function getUserDetail(id:number){
      const data = {Id:id}
      userDetailApi(data).then((res:any)=>{
        if(res&& res.state===0){
          localStorage.setItem('userInfo',JSON.stringify(res.content))
          store.commit('setUserInfo',res.content)
        }
      })
    }
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    function logout(){
      localStorage.clear()
      router.push({path:'/login'})
    }
    //*********** DOM FUN end **********//

    return {
      logout,store,baseUrl,avatar,userInfo
    }
  },
});
</script>
<style lang="scss">
.header_wrapper{
  background: #fff; width: 100%;
  .header{
    width: 1200px; margin: 0 auto; padding: 10px 0;
    .logo{padding-top: 10px;}
    .logo img{height: 60px;}
    .top_nav li{float: left; padding: 30px 20px;}
    .top_nav li a{
      font-size: 18px; color: #666;
      &:hover{
        color: #c82434;
      }
    }
    .top_other{padding: 20px 0;
      ul{display: flex; justify-items: center; align-items:center}
    }
    .top_other li{
      color: #999; cursor: pointer; padding-right: 10px;
    }
    .top_other li:nth-child(2){border-right: 1px solid #ccc;}
    .top_other li:nth-child(3){padding-left: 15px;}
    .el-avatar>img{width: 100%;}
  }
}
</style>
